import Cookies from 'js-cookie';

export const initBOCookieBar = () => {
  const cookieBar = document.querySelector(".cookieBar");
  if (cookieBar) {
    const reject = cookieBar.querySelector('.reject');
    const accept = cookieBar.querySelector('.accept');

    if( !Cookies.get('BOcustomCookieBar') ){
      cookieBar.classList.add('open');
    }

    reject.addEventListener("click", () => {
      location.href = "https://google.com";
    });

    accept.addEventListener("click", () => {
      cookieBar.classList.remove('open');
      setCookies();
    });

    const setCookies = () => {
      Cookies.set('BOcustomCookieBar', 1, {
        expires: 365
      });
    }
  }
}